module.exports = __webpack_public_path__ + "static/media/m-plusbubble.1d57bdf8.png";